<script setup lang="ts">
    import { computed, watch, onMounted } from 'vue'
    import { useId } from '@common/composables'
    import { useOverallReportPage } from '@RankHR/Regions/pages-core'

    document.title = "Summary Report"

    const id = useId()

    const { useOverallReportQuery } = useOverallReportPage()
    const { modelOverallReportQueryV1, runOverallReportQueryV1 } = useOverallReportQuery(id)

    const model = computed(() => modelOverallReportQueryV1.value)
    const regionName = computed(() => modelOverallReportQueryV1.value?.RegionName)
    const votingCycle = computed(() => modelOverallReportQueryV1.value?.VotingCycle)
    const totalPossibleScore = computed(() => modelOverallReportQueryV1.value?.TotalPossibleScore)
    const boardHighScore = computed(() => modelOverallReportQueryV1.value?.BoardHighScore)
    const boardAverage = computed(() => modelOverallReportQueryV1.value?.BoardAverage)
    const boardRanking = computed(() => modelOverallReportQueryV1.value?.BoardRanking)
    const overallBoardScoringStatistics = computed(() => modelOverallReportQueryV1.value?.OverallBoardScoringStatistics)
    const ratingRatios = computed(() => modelOverallReportQueryV1.value?.RatingRatios)
    const error = computed(() => modelOverallReportQueryV1.value?.Error)

    onMounted(() => {
        runOverallReportQueryV1()
    })
</script>

<template>
    <div>
        <div id="navigationPlaceholder">
            <WorkspaceNavigation :workspaceId="$route.params.id" workspaceName="Workspace"></WorkspaceNavigation>
        </div>

        <div class="container-fluid" style="margin-top: 50px;">
            <div class="row">
                <div class="col-lg-12">
                    <div v-if="model" style="margin: 30px;">
                        <div v-if="!error">
                            <h2 class="text-center">Summary Report</h2>
                            <p class="lead text-center">Region: {{regionName }}, Voting cycle: {{votingCycle}}</p>
                            <br /><br />

                            <h3 class="text-center">Board Ranking</h3>
                            <br />
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th class="text-center" v-for="header in boardRanking.Header.Headers">{{header}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in boardRanking.Rows">
                                            <td v-for="val in row.Values" class="text-center">{{val}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />

                            <h3 class="text-center">Overall Board Scoring Statistics</h3>
                            <br />
                            <table>
                                <tr>
                                    <td><strong>Total Possible Score:</strong></td>
                                    <td class="text-right">{{totalPossibleScore}}</td>
                                </tr>

                                <tr>
                                    <td><strong>Board High Score:</strong></td>
                                    <td class="text-right">{{boardHighScore}}</td>
                                </tr>

                                <tr>
                                    <td><strong>Board Average:</strong></td>
                                    <td class="text-right">{{boardAverage}}</td>
                                </tr>
                            </table>
                            <br />
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th class="text-center" v-for="header in overallBoardScoringStatistics.Header.Headers">{{header}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in overallBoardScoringStatistics.Rows">
                                            <td v-for="val in row.Values" class="text-center">{{val}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />

                            <h3 class="text-center">Rating Ratios</h3>
                            <br />
                            <div class="table-responsive">
                                <div v-if="ratingRatios" class="table-responsive">
                                    <table class="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th class="text-center" v-for="header in ratingRatios.Header.Headers">{{header}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row in ratingRatios.Rows">
                                                <td v-for="val in row.Values" class="text-center">{{val}}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>

                    <div v-else style="margin: 30px;">
                        <h1>{{error}}</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
